const reg = {
    // 护照号
    passport: /^([A-Z,0-9]{5,20})$/,
    // 身高
    height: /^\d{1,3}$/,
    // 体重
    weight: /^\d{1,3}$/,
    // 邮编
    postcode: /^[0-9]{6}$/,
    // 传真
    // fax: /^((\d{3,5})|(\d{3,5}-))?\d{7,10}$/,
    // 邮箱
    email: /^[0-9,a-z,A-Z,\!\#\*\&\%\.\_]+@[0-9,a-z,A-Z]+\.[0-9,a-z,A-Z]+$/,
    // 姓氏
    family_name_spell: /^[a-zA-Z]+$/,
    // 名字
    given_name_spell: /^[a-zA-Z]+$/,
};
export default {
    data() {
        return {
            rules: {
                // 姓名
                user_name: [
                    {required: true, message: '请输入姓名', trigger: 'blur'},
                ],
                // 姓氏
                family_name_spell: [
                {required: true,
                  validator: (rule, value, callback) => {
                    let msg='请输入拼音大写,例如张三,输入:ZHANG';
                    this.switch_pinyin && (msg='姓名不区分姓氏和名的少数民族学员填写,例如巴桑次仁,输入：BASANGCIREN');
                    if (!value) {
                      callback(new Error(msg));
                    } else {
                      reg.family_name_spell.test(value)
                        ? callback()
                        : callback(new Error(msg));
                    }
                  },
                  trigger: 'change'},
                /*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
              ],
                // 姓名
                given_name_spell: [
                    {required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入名(拼音)大写,例如张三,输入:SAN'))
                            } else {
                                reg.given_name_spell.test(value)
                                    ? callback()
                                    : callback(new Error('请输入名(拼音)大写,例如张三,输入:SAN'));
                            }
                        },
                        trigger: 'change'},
                    /*{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
                ],
                // 性别
                gender: [
                    {required: false, message: '请选择性别', trigger: 'change'},
                ],
                // 出生日期，时间戳
                date_of_birth: [
                    {required: false, message: '请选择出生日期', trigger: 'change'},
                ],
                mobile_phone:[
                    {
                        required: true,
                        validator: (rule, val, callback) => {
                            if (!this.$yioks.phone(val)) {
                                callback(new Error("请输入有效的手机号码"));
                            } else {
                                if (!this.phoneFlag) {
                                    callback();
                                } else {
                                    this.phoneFlag = false;
                                    callback(new Error(this.phoneMsg));
                                }
                            }
                        },
                        trigger: "blur"
                    }
                ],
                id_number:[{
                    required: true,
                    validator: (rule, val, callback) => {
                      if(this.formData.id_type === 'id_number'){
                        if (!val){
                          callback(new Error("请输入身份证号"));
                        } else{
                          if (this.$yioks.idCard_number(val)) {
                            callback();
                          }else {
                            callback(new Error("请输入正确的身份证信息"));
                          }
                        }
                      }else{
                        callback();
                      }

                    },
                    trigger: "blur",
                }],
                code: [
                    {
                        required: true,
                        validator: (rule, val, callback) => {
                            if (!this.$yioks.code(val)) {
                                callback(new Error("请输入有效的验证码"));
                            } else {
                                if (!this.numberFlag) {
                                    callback();
                                } else {
                                    this.numberFlag = false;
                                    callback(new Error(this.numberMsg));
                                }
                            }
                        },
                        trigger: "blur"
                    }
                ],
            },
        };
    },
};
